import { render, staticRenderFns } from "./list.vue?vue&type=template&id=2d23fa42&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kasingkhoo/NestJsProjects/ivm_web_ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d23fa42')) {
      api.createRecord('2d23fa42', component.options)
    } else {
      api.reload('2d23fa42', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=2d23fa42&", function () {
      api.rerender('2d23fa42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/list.vue"
export default component.exports